import { load, type ReCaptchaInstance } from 'recaptcha-v3';
import RytmWebflow from 'rytm-webflow';

const instanceBySiteKey = new Map<string, Promise<ReCaptchaInstance>>();

const loadInstance = (siteKey: string): Promise<ReCaptchaInstance> => {
  let cached = instanceBySiteKey.get(siteKey);
  if (!cached) {
    cached = load(siteKey, { autoHideBadge: true });
    instanceBySiteKey.set(siteKey, cached);
  }
  return cached;
};

const onDocumentFormSubmit = async (e: Event): Promise<void> => {
  const form = e.target as HTMLElement | null;
  if (!form || !(form instanceof HTMLFormElement)) return;

  const protectEl = form.querySelector<HTMLElement>(
    '[data-form-protection="recaptchav3"]',
  );
  if (!protectEl) return;

  const { siteKey, actionName, recaptchaId } = protectEl.dataset;
  if (!siteKey || !actionName || !recaptchaId) {
    console.error('[reCaptchaV3] Missing protection data on form', form);
    return;
  }

  e.preventDefault();
  form.classList.add('loading');

  try {
    const recaptcha = await loadInstance(siteKey);
    const token = await recaptcha.execute(actionName);

    form
      .querySelectorAll<HTMLInputElement>(
        `input[type="hidden"][name="${CSS.escape(recaptchaId)}"]`,
      )
      .forEach((el) => el.remove());

    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = recaptchaId;
    tokenInput.value = token;
    form.appendChild(tokenInput);

    RytmWebflow.aswap.formSubmit(form);
  } catch (err) {
    console.error('[reCaptchaV3] Failed to obtain token', err);
    form.classList.remove('loading');
  }
};

export const initReCaptchaV3 = (): void => {
  document.addEventListener('submit', onDocumentFormSubmit);
};
